import React from 'react';

export const IconSmallCopyLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path
            d="M4 5a1 1 0 011-1h8a1 1 0 011 1v2h-2V6H6v11h4v2H5a1 1 0 01-1-1V5zm6 14h2v2h-1a1 1 0 01-1-1v-1zm0-2h2v-2h-2v2zm2-10h-1a1 1 0 00-1 1v1h2V7zm2 0h2v2h-2V7zm-4 6v-2h2v2h-2zm4 8h2v-2h-2v2zm5 0h-1v-2h2v1a1 1 0 01-1 1zm1-4v-2h-2v2h2zm0-6v2h-2v-2h2zm0-2V8a1 1 0 00-1-1h-1v2h2z"
            fill="#374050"
            fillRule="evenodd"
        />
    </svg>
);
